// extracted by mini-css-extract-plugin
module.exports = {"pintxo-icon-button":"IconButton_pintxo-icon-button__EfWi2"};